import { render, staticRenderFns } from "./DashboardTasks.vue?vue&type=template&id=172dfe44&scoped=true&"
import script from "./DashboardTasks.vue?vue&type=script&lang=js&"
export * from "./DashboardTasks.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTasks.vue?vue&type=style&index=0&id=172dfe44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172dfe44",
  null
  
)

export default component.exports